import React, { useCallback, useContext, useEffect, useState } from 'react';
import './Siteplan.css';
import lotMap from '../../assets/lotMap.png';
import siteplan from '../../assets/siteplan.jpg';
import ImageMapper from 'react-img-mapper';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import CloseIcon from '@material-ui/icons/Close';
import HouseIcon from '@material-ui/icons/House';
import {
	Chip,
	Input,
	InputLabel,
	MenuItem,
	Select,
	TablePagination,
	TableSortLabel,
} from '@material-ui/core';
import { forEach } from 'lodash';
import { useHistory } from 'react-router';

import { CircularProgress } from '@material-ui/core';
import Modal from '../layout/modal/Modal';
import Clients from '../clients/Clients';
import StopIcon from '@material-ui/icons/Stop';

//redux
import { connect } from 'react-redux';
import getCoBrokers from '../../api/Siteplan/getCoBrokers.api';
import SearchBox from '../searchBox/SearchBox';
import dayjs from 'dayjs';
import Edit from '@material-ui/icons/Edit';
import EditLot from './EditLot/EditLot';
import { legendData } from './legend.data';
import saveCoBroker from '../../api/Siteplan/saveCoBroker.api';
import saveAvailability from '../../api/Siteplan/saveAvailability.api';
import saveSalesAgents from '../../api/Siteplan/saveSalesAgents.api';
import ViewHistory from './History/ViewHistory';
import getEditHistory from '../../api/Siteplan/getEditHistory.api';
import { numberWithCommas } from '../../utils/numberWithCommas';
import setLotToAvailable from '../../api/Agreement/setLotToAvailable.api';

const Siteplan = ({ userType, userDetails, clients }) => {
	const [hoveredArea, setHoveredArea] = useState();
	const { firebase } = useContext(FirebaseContext);
	const [lotList, setLotList] = useState([]);
	const [priceDetailList, setPriceDetailList] = useState();
	const [listOfLots, setListOfLots] = useState([]);
	const [availability, setAvailability] = useState({});
	const [salesAgent, setSalesAgent] = useState([]);
	const [personName, setPersonName] = useState();
	const [clickLotInfo, setClickLotInfo] = useState();
	const [lotId, setLotId] = useState();
	const [mapCoords, setMapCoords] = useState({
		name: 'my-map',
	});
	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('');
	const [selected, setSelected] = useState([]);
	const [page, setPage] = useState(0);
	const [dense, setDense] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [toolTipData, setToolTipData] = useState([]);
	const [center, setCenter] = useState();
	const [toolTipHouseIconAvailable, setToolTipHouseIconAvailable] = useState(
		[]
	);
	const [toolTipHouseIconPending, setToolTipHouseIconPending] = useState([]);
	const [coBroker, setCoBroker] = useState();
	const [coBrokersArr, setCoBrokersArr] = useState();
	const [show, setShow] = useState(false);
	const [searchField, setSearchField] = useState('');
	const [filteredLots, setFilteredLots] = useState();
	const [viewEditModal, setViewEditModal] = useState(false);
	const [editLotInfo, setEditLotInfo] = useState();
	const [showEditHistory, setShowEditHistory] = useState(false);
	const [selectLot, setSelectLot] = useState([]);
	const [historyTrails, setHistoryTrails] = useState();
	const [resetPage, setResetPage] = useState(false);

	//search functionality
	useEffect(() => {
		const filtered = listOfLots.filter(
			(lot) =>
				lot['lot'].toString().includes(searchField) ||
				lot.availability
					.toLowerCase()
					.includes(searchField.toLowerCase()) ||
				(lot?.salesAgent &&
					lot?.salesAgent
						.toLowerCase()
						.includes(searchField.toLowerCase()))
		);

		setFilteredLots(filtered);
	}, [searchField, listOfLots]);

	const closeModalHandler = () => {
		if (show === true) {
			setShow(false);
		} else if (viewEditModal === true) {
			setViewEditModal(false);
		} else if (showEditHistory === true) {
			setShowEditHistory(false);
			setResetPage(true);
		}
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const history = useHistory();

	const handleRequestSort = (property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	function descendingComparator(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getComparator(order, orderBy) {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	}

	function stableSort(array, comparator) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map((el) => el[0]);
	}

	useEffect(() => {
		getCoBrokers((returned) => setCoBrokersArr(returned));
	}, []);

	//setting up the map
	useEffect(async () => {
		await firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.on('value', (snapshot) => {
				var mapCoordObj;
				var areaArr = [];

				snapshot.forEach((lot) => {
					var mapCoordVal = lot.val()?.mapCoords;

					var coordsArray = mapCoordVal.coords;

					var maxX, maxY, center;
					var coord,
						minX = (maxX = parseInt(coordsArray[0], 10)),
						minY = (maxY = parseInt(coordsArray[1], 10));

					for (var i = 0, l = coordsArray.length; i < l; i++) {
						coord = parseInt(coordsArray[i], 10);
						if (i % 2 == 0) {
							// Even values are X coordinates
							if (coord < minX) {
								minX = coord;
							} else if (coord > maxX) {
								maxX = coord;
							}
						} else {
							// Odd values are Y coordinates
							if (coord < minY) {
								minY = coord;
							} else if (coord > maxY) {
								maxY = coord;
							}
						}
					}

					center = [
						parseInt((minX + maxX) / 2, 10),
						parseInt((minY + maxY) / 2, 10),
					];

					// ---------DO NOT REMOVE THIS COMMENT ----------------------
					//Uncomment to populate db then comment it back! - This is to get the center coordinates of the each lots

					// var lotRef = firebase
					// 	.database()
					// 	.ref(
					// 		'/kavtek_clients/' +
					// 			PROJECT_CODE.projectCode +
					// 			'/lots'
					// 	)
					// 	.child(lot.key);

					// lotRef.update({
					// 	center: center,
					// });
					// -------------------------------------------------

					if (userType === 'cobroker') {
						if (lot.val()?.coBroker == userDetails.email) {
							if (lot.val().available === 'soldout') {
								mapCoordVal['preFillColor'] =
									'rgba(255, 0, 0, 0.47)';
							}
							if (lot.val().available === 'available') {
								mapCoordVal['preFillColor'] = '';
							}
							if (lot.val().available === 'pending') {
								mapCoordVal['preFillColor'] =
									'rgba(255, 255, 168, 0.70)';
							}
							if (lot.val().available === 'hold') {
								mapCoordVal['preFillColor'] =
									'rgba(97, 97, 97, 1)';
								mapCoordVal['disabled'] = true;
							}
						} else {
							mapCoordVal['preFillColor'] = '#ccc';
							mapCoordVal['disabled'] = true;
						}
					} else {
						if (lot.val().available === 'soldout') {
							mapCoordVal['preFillColor'] =
								'rgba(255, 0, 0, 0.47)';
							mapCoordVal['name'] = 'soldout';
						}
						if (lot.val().available === 'available') {
							mapCoordVal['preFillColor'] = '#3cc33cb8';
							mapCoordVal['name'] = mapCoordVal['id'];
						}
						if (lot.val().available === 'pending') {
							mapCoordVal['preFillColor'] =
								'rgba(255, 255, 168, 0.70)';
							mapCoordVal['name'] = 'pending';
						}
						if (lot.val().available === 'hold') {
							mapCoordVal['preFillColor'] = 'rgba(97, 97, 97, 1)';
							mapCoordVal['disabled'] = true;
							mapCoordVal['name'] = 'hold';
						}
					}

					areaArr.push(mapCoordVal);

					mapCoordObj = {
						...mapCoords,
						areas: areaArr,
					};
				});

				// console.log('areaa: ' + areaArr);

				setMapCoords(mapCoordObj);

				console.log('mapppp: ', mapCoordObj);
			});
	}, []);

	//set default value for multi select (assigning sales agent)
	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.on('value', (snapshot) => {
				var lotDetails;
				var cbDetails;
				snapshot.forEach((lot) => {
					var lotName = lot.key;

					var sa = lot.val().salesAgent;
					var cb = lot.val().coBroker;

					if (sa === undefined) {
						sa = [];
					}

					if (cb === undefined) {
						cb = '';
					}

					// console.log('keyssss: ' + sa);

					lotDetails = {
						...lotDetails,
						['agent' + lotName]: sa,
					};

					cbDetails = {
						...cbDetails,
						['cobroker' + lotName]: cb,
					};
				});
				console.log('cbDetails ', cbDetails);
				console.log('lotDetails ', lotDetails);
				setPersonName(lotDetails);
				setCoBroker(cbDetails);
			});
	}, []);

	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.on('value', (snapshot) => {
				var lotListArr = [];
				var availabilityArr = [];
				var lotAssignment;
				var availabilityObj;

				snapshot.forEach((lot) => {
					var lotName = lot.val().lotId;
					var availabilityValue = lot.val()?.available;
					var coBrokerValue = lot.val()?.coBroker;
					var salesAgentsValue = lot.val()?.salesAgent;
					var closingDateValue = lot.val()?.closingDate;
					var premiumValue = lot.val()?.lotPrice;
					var premiumDescription = lot.val()?.premiumDescription;
					var lotSize = lot.val()?.lotSize;

					lotAssignment = {
						lot: lotName,
						availability: availabilityValue,
						salesAgent: salesAgentsValue?.toString(),
						closingDate: closingDateValue,
						premiumValue: premiumValue,
						premiumDescription: premiumDescription,
						lotSize: lotSize,
					};

					availabilityObj = {
						...availabilityObj,
						[`lot` + lotName]: availabilityValue,
					};

					if (userType === 'cobroker') {
						if (userDetails.email == coBrokerValue) {
							console.log('userDetails.email', userDetails.email);
							console.log('coBrokerValue', coBrokerValue);
							lotListArr.push(lotAssignment);
						}
					} else {
						lotListArr.push(lotAssignment);
					}
				});

				setAvailability(availabilityObj);
				setListOfLots(lotListArr);
				console.log('listArr: ', lotListArr);
				// console.log('availabilityArr: ' + JSON.stringify(availabilityArr));
			});
	}, []);

	//get sales agent
	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
			.on('value', (snapshot) => {
				var salesAgentArr = [];

				snapshot.forEach((sa) => {
					var name = sa.val().name;

					salesAgentArr.push(name);
				});

				setSalesAgent(salesAgentArr);

				// console.log('Sales agent: ' + salesAgentArr);
			});
	}, []);

	//handle radio buttons for availability
	const handleAvailability = (e) => {
		var lotName = e.target.name;
		var availabilityValue = e.target.value;

		setAvailability({
			...availability,
			['lot' + lotName]: availabilityValue,
		});

		saveAvailability(lotName, availabilityValue);
	};

	const handleSalesAgent = (e) => {
		var lotName = e.target.name;
		var targetValue = e.target.value;
		var valueVal = JSON.stringify(targetValue);

		setPersonName({ ...personName, ['agent' + lotName]: e.target.value });

		saveSalesAgents(lotName, valueVal);
	};

	const handleChangeCoBroker = (e) => {
		console.log('eeeee', e);
		var coBrokerValue = e.target?.value;
		var lotName = e.target?.name;
		if (e.target.value) {
			setCoBroker({
				...coBroker,
				['cobroker' + lotName]: e?.target?.value,
			});
		}

		saveCoBroker(lotName, coBrokerValue);
	};

	const handleSelectLot = useCallback(async (e) => {
		try {
			var currentUserId = firebase.auth().currentUser.uid;
			var currentUserEmail = firebase.auth().currentUser.email;
			var currentUserType;
			var currentUserPhoneNumber;
			var currentUserName;
			var lotId = e.currentTarget.dataset.lotid;

			await firebase
				.database()
				.ref('/users/' + currentUserId)
				.once('value', (snapshot) => {
					currentUserType = snapshot.val().userType;
					currentUserPhoneNumber = snapshot.val().phoneNumber;
					currentUserName = snapshot.val().fullName;

					console.log(
						'Type: ' +
							currentUserType +
							', username: ' +
							currentUserName +
							', phone: ' +
							currentUserPhoneNumber
					);

					var detailsUser = {
						thisEmail: currentUserEmail,
						thisName: currentUserName,
						thisUserType: currentUserType,
						thisPhone: currentUserPhoneNumber,
						thisUID: currentUserId,
					};

					if (userType === 'client') {
						history.push({
							pathname: '/doc-client',
							state: {
								userDetail: detailsUser,
								sellerFullName: currentUserName,
								sellerPhone: currentUserPhoneNumber,
								lotId: lotId,
							},
						});
					}
				});
		} catch (error) {
			console.log(error);
		}
	});

	const handleClickLot = async (area) => {
		console.log(`${area.name} is clicked`);

		function capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}

		var buildingArr = [];
		var priceDetailArr = [];
		var buildingDetails;
		var lotSelected = area.name;

		var coBrokerValue;

		firebase
			.database()
			.ref(
				'/kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/lots/' +
					lotSelected
			)
			.once('value', (snapshot) => {
				coBrokerValue = snapshot.val()?.coBroker;
			});

		if (userType === 'cobroker') {
			if (userDetails.email == coBrokerValue) {
				firebase
					.database()
					.ref(
						'/kavtek_clients/' +
							PROJECT_CODE.projectCode +
							'/lots/' +
							lotSelected +
							'/buildings/'
					)
					.on('value', (snapshot) => {
						snapshot.forEach((snap) => {
							// console.log(snap.val()); //building name

							snap.forEach((building) => {
								buildingDetails = {
									name: capitalizeFirstLetter(building.key),
									price: building.val().priceList,
									sqft: building.val().sqft,
								};

								buildingArr.push(buildingDetails);
							});
						});
						console.log(buildingArr);
						setLotList(buildingArr);
					});

				var lotId = area.id;
				var lotObj;

				firebase
					.database()
					.ref(
						'/kavtek_clients/' +
							PROJECT_CODE.projectCode +
							'/lots/' +
							lotId
					)
					.on('value', (snapshot) => {
						var price = snapshot.val().lotPrice;
						var availability = snapshot.val().available;
						var premiumDescription =
							snapshot.val()?.premiumDescription;
						var pricing = snapshot.val()?.pricing;

						var pricingKeys = Object.keys(pricing);

						var pricingArr = [];
						var totalPriceArr = [];

						pricingKeys?.map((key) => {
							var pricingObj = {
								name: pricing[key].name,
								price: pricing[key].price,
							};

							totalPriceArr.push(pricing[key].price);

							pricingArr.push(pricingObj);
						});

						var totalPremium = totalPriceArr.reduce(
							(a, b) => a + b,
							0
						);

						console.log('pricingArr', pricingArr);

						lotObj = {
							price: price,
							availability: availability,
							lot: lotId,
							center: area.center,
							premiumDescription: premiumDescription,
							pricing: pricingArr,
						};

						setLotId(lotObj.lot);

						setClickLotInfo(lotObj);
					});
			}
		} else {
			firebase
				.database()
				.ref(
					'/kavtek_clients/' +
						PROJECT_CODE.projectCode +
						'/lots/' +
						lotSelected +
						'/buildings/'
				)
				.on('value', (snapshot) => {
					snapshot.forEach((snap) => {
						// console.log(snap.val()); //building name

						snap.forEach((building) => {
							buildingDetails = {
								name: capitalizeFirstLetter(building.key),
								price: building.val().priceList,
								sqft: building.val().sqft,
							};

							buildingArr.push(buildingDetails);
						});
					});
					console.log(buildingArr);
					setLotList(buildingArr);
				});

			var lotId = area.id;
			var lotObj;

			firebase
				.database()
				.ref(
					'/kavtek_clients/' +
						PROJECT_CODE.projectCode +
						'/lots/' +
						lotId
				)
				.on('value', (snapshot) => {
					var price = snapshot.val().lotPrice;
					var availability = snapshot.val().available;
					var premiumDescription = snapshot.val()?.premiumDescription;

					var pricing = snapshot.val()?.pricing;

					var pricingKeys = pricing && Object.keys(pricing);

					var pricingArr = [];
					var totalPriceArr = [];

					pricingKeys?.map((key) => {
						var pricingObj = {
							name: pricing[key].name,
							price: pricing[key].price,
						};

						totalPriceArr.push(pricing[key].price);

						pricingArr.push(pricingObj);
					});

					var totalPremium = totalPriceArr.reduce((a, b) => a + b, 0);

					console.log('pricingArr', pricingArr);

					lotObj = {
						price: numberWithCommas(price),
						availability: availability,
						lot: lotId,
						center: area.center,
						premiumDescription: premiumDescription,
						pricing: pricingArr,
					};

					setLotId(lotObj.lot);

					setClickLotInfo(lotObj);
				});
		}
	};

	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.orderByChild('available')
			.equalTo('soldout')
			.once('value', (snapshot) => {
				var tooltipDataArr = [];
				snapshot.forEach((lot) => {
					var center = lot.val().center;

					var centerObj = {
						center: center,
					};

					tooltipDataArr.push(centerObj);
				});

				setTimeout(() => {
					setToolTipData(tooltipDataArr);
				}, 1000);
			});
	}, [mapCoords]);

	useEffect(() => {
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.orderByChild('available')
			.equalTo('available')
			.once('value', (snapshot) => {
				var tooltipDataArr = [];
				snapshot.forEach((lot) => {
					var center = lot.val().center;

					var centerObj = {
						center: center,
					};

					if (userType === 'cobroker') {
						if (lot.val()?.coBroker == userDetails.email) {
							tooltipDataArr.push(centerObj);
						}
					} else {
						tooltipDataArr.push(centerObj);
					}
				});

				setTimeout(() => {
					setToolTipHouseIconAvailable(tooltipDataArr);
				}, 1000);
			});
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode + '/lots')
			.orderByChild('available')
			.equalTo('pending')
			.once('value', (snapshot) => {
				var tooltipDataArr = [];
				snapshot.forEach((lot) => {
					var center = lot.val().center;
					var centerObj = {
						center: center,
					};

					if (userType === 'cobroker') {
						if (lot.val()?.coBroker == userDetails.email) {
							tooltipDataArr.push(centerObj);
						}
					} else {
						tooltipDataArr.push(centerObj);
					}
				});

				setTimeout(() => {
					setToolTipHouseIconPending(tooltipDataArr);
				}, 1000);
			});
	}, [mapCoords]);

	const enterArea = (area) => {
		var lotSelected = area.name;

		console.log('This is the entered area', area);

		var coBrokerValue;

		firebase
			.database()
			.ref(
				'/kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/lots/' +
					lotSelected
			)
			.once('value', (snapshot) => {
				coBrokerValue = snapshot.val()?.coBroker;
			});

		if (userType === 'cobroker') {
			if (userDetails.email == coBrokerValue) {
				setHoveredArea(area);
			}
		} else {
			setHoveredArea(area);
		}
	};

	const handleMouseMove = (area, index, event) => {
		return {
			top: `${area.center[1]}px`,
			left: `${area.center[0] + 90}px`,
		};
	};

	const handleMouseLeave = (event) => {
		setHoveredArea();
	};

	const useStyles = makeStyles((theme) => ({
		root: {
			minWidth: 275,
			margin: 10,

			'&:nth-child(1)': {
				marginLeft: '0',
			},
		},

		cardsGroup: {
			display: 'flex',
			flexWrap: 'nowrap',
			marginLeft: '6.5em',
			overflowX: 'scroll',
			marginRight: '6.5em',
		},

		title: {
			fontSize: 21,
		},
		pos: {
			marginBottom: 12,
		},
		btnGroup: {
			display: 'flex',
		},

		btn: {
			margin: '8px',
			backgroundColor: '#438afe',
			color: 'white',
			marginBottom: '10px',
		},
		mapImage: {
			position: 'relative',
			width: '1013px',
			height: 'auto',
			margin: '0 auto',
		},
		table: {
			minWidth: 650,
		},
		tableContainer: {
			marginTop: '1em',
			width: '85%',
			margin: 'auto',
		},
		radioGroup: {
			display: 'flex',
			flexDirection: 'row',
		},
		radioBtn: {
			color: 'rgb(71, 131, 230) !important',
		},
		formControl: {
			margin: theme.spacing(1),
			minWidth: 120,
			maxWidth: 300,
		},
		chips: {
			display: 'flex',
			flexWrap: 'wrap',
		},
		chip: {
			margin: 2,
		},
		noLabel: {
			marginTop: theme.spacing(3),
		},
	}));

	const ITEM_HEIGHT = 48;
	const ITEM_PADDING_TOP = 8;
	const MenuProps = {
		PaperProps: {
			style: {
				maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
				width: 250,
			},
		},
	};

	function getStyles(name, personName, theme) {
		return {
			fontWeight:
				personName.indexOf(name) === -1
					? theme.typography.fontWeightRegular
					: theme.typography.fontWeightMedium,
		};
	}

	const styles = useStyles();
	const theme = useTheme();

	const toolTipStyle = (top, left) => {
		return {
			top: `${top}px`,
			left: `${left + 90}px`,
		};
	};

	const handleCloseTooltip = () => {
		setClickLotInfo();
	};

	const handleSearch = (e) => {
		setSearchField(e.target.value);
	};

	const openEditModal = (e) => {
		var lotId = e.currentTarget.dataset.lot;
		var closingDate = e.currentTarget.dataset.closingdate;
		var premium = e.currentTarget.dataset.premium;
		var premiumDescription = e.currentTarget.dataset.description;
		setViewEditModal(true);
		setShowEditHistory(false);
		setEditLotInfo({
			lotId: lotId,
			closingDate: closingDate,
			premium: premium,
			premiumDescription: premiumDescription,
		});
	};

	const handleEditBatch = (e) => {
		console.log('handleEditBatch e', selectLot);
		var lotIds = Object.keys(selectLot);

		console.log('this is the select lot', selectLot);

		var lotArr = selectLot.map((x) => Number(x));

		setViewEditModal(true);
		setShowEditHistory(false);
		setEditLotInfo({
			lotId: lotArr.join(', '),
			closingDate: dayjs(new Date()).format('YYYY-MM-DD'),
			premium: '',
			premiumDescription: '',
			source: 'batch',
		});
	};

	const handleHistory = () => {
		closeModalHandler();
		setShowEditHistory(true);

		console.log('editLotInfo.lotId', editLotInfo.lotId);
		getEditHistory(editLotInfo.lotId, (returned) =>
			setHistoryTrails(returned)
		);
	};

	const handleSelectLots = (e, lot) => {
		const selectedIndex = selectLot.indexOf(lot);
		console.log('handlsela', selectedIndex);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selectLot, lot);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selectLot.slice(1));
		} else if (selectedIndex === selectLot.length - 1) {
			newSelected = newSelected.concat(selectLot.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selectLot.slice(0, selectedIndex),
				selectLot.slice(selectedIndex + 1)
			);
		}
		setSelectLot(newSelected);
	};

	useEffect(() => {
		console.log('selectLot', selectLot);
	}, [selectLot]);
	const isSelected = (name) => selectLot.indexOf(name) !== -1;

	return (
		<>
			<div className='siteplan-page'>
				<h2 id='siteplan-title'>Siteplan</h2>
				<div className='legend_group'>
					{legendData.map((legend) => (
						<div className='legend_label_group'>
							<div
								className='legend_status'
								style={{
									marginTop: '5px',
									color: `${legend.color}`,
								}}
							>
								{legend.icon}
							</div>
							<div className='legend_label'>{legend.label}</div>
						</div>
					))}

					{userType === 'cobroker' && (
						<div className='legend_label_group'>
							<div
								className='legend_status'
								style={{
									marginTop: '5px',
									color: '#ccc',
								}}
							>
								<StopIcon />
							</div>
							<div className='legend_label'>Locked</div>
						</div>
					)}
				</div>

				{mapCoords.areas && toolTipData ? (
					<div className='map-container'>
						<ImageMapper
							src={siteplan}
							map={mapCoords}
							stayHighlighted={'true'}
							areaKeyName={mapCoords.areas.id}
							fillColor={'rgba(71, 131, 230, 0.70)'}
							strokeColor={'rgba(71, 131, 230)'}
							onMouseEnter={(area) => {
								enterArea(area);
								handleMouseMove(area);
							}}
							onClick={(area) => {
								handleClickLot(area);
							}}
							onMouseLeave={(event) => {
								handleMouseLeave(event);
							}}
							className={styles.mapImage}
						/>
						{hoveredArea && (
							<span
								className='tooltip'
								style={{ ...handleMouseMove(hoveredArea) }}
							>
								{console.log(
									'hoveredArea.name',
									hoveredArea.name
								)}
								{hoveredArea.name}
							</span>
						)}
						{clickLotInfo && (
							<span
								className='tooltip-click'
								style={{
									...toolTipStyle(
										clickLotInfo?.center[1],
										clickLotInfo?.center[0]
									),
								}}
							>
								{clickLotInfo && (
									<div className='tooltip-content'>
										<div
											className='close-tooltip'
											onClick={handleCloseTooltip}
										>
											<CloseIcon />
										</div>
										<h1>Lot {clickLotInfo?.lot}</h1>
										<p>
											Lot Status:{' '}
											{clickLotInfo?.availability}
										</p>
										{clickLotInfo?.pricing?.map((price) => {
											return (
												<p>{`${price.name}:  ${price.price}`}</p>
											);
										})}
										<p>Premium: $ {clickLotInfo?.price}</p>
										{/* {clickLotInfo?.premiumDescription && (
											<p>
												Premium Description:{' '}
												{
													clickLotInfo?.premiumDescription
												}
											</p>
										)} */}
										{/* {clickLotInfo?.availability ===
											'soldout' ||
										clickLotInfo?.availability ===
											'pending' ? null : (
											<button
												className='tooltip-button btn btn-primary'
												data-lotid={clickLotInfo?.lot}
												onClick={(e) => {
													setShow(true);
													setClickLotInfo();
													handleSelectLot(e);
												}}
											>
												Select Lot
											</button>
										)} */}
									</div>
								)}
							</span>
						)}

						{toolTipHouseIconAvailable?.map((tooltip) => {
							if (tooltip.center) {
								return (
									<div
										className='tooltip-available'
										style={{
											...toolTipStyle(
												tooltip?.center[1],
												tooltip?.center[0]
											),
										}}
									>
										<HouseIcon />
									</div>
								);
							}
						})}
						{toolTipHouseIconPending?.map((tooltip) => {
							if (tooltip.center) {
								return (
									<div
										className='tooltip-pending'
										style={{
											...toolTipStyle(
												tooltip?.center[1],
												tooltip?.center[0]
											),
										}}
									>
										<HouseIcon />
									</div>
								);
							}
						})}
					</div>
				) : (
					<div className={styles.mapImage}>
						<CircularProgress />
					</div>
				)}

				{clickLotInfo && (
					<div className={styles.cardsGroup}>
						{lotList?.map((lot) => {
							return (
								<Card className={styles.root} key={lot.name}>
									<CardContent>
										<Typography
											className={styles.pos}
											color='textSecondary'
										>
											Building Name
											<Typography
												className={styles.title}
												color='textPrimary'
												gutterBottom
											>
												{lot.name}
											</Typography>
											Building Number & Price
											{lot.price.map((priceItem) => {
												return (
													<>
														<Typography
															className={
																styles.title
															}
															color='textPrimary'
															gutterBottom
														>
															{priceItem.id} - $
															{priceItem.price}
														</Typography>
													</>
												);
											})}
											Building sqft
											<Typography
												className={styles.title}
												color='textPrimary'
												gutterBottom
											>
												{lot.sqft}
											</Typography>
										</Typography>
									</CardContent>
								</Card>
							);
						})}
					</div>
				)}
				<div className={styles.tableContainer}>
					<SearchBox
						placeholder='Search lots, assigned agents, availabilities...'
						handleChange={handleSearch}
					/>
				</div>
				<TableContainer
					component={Paper}
					className={styles.tableContainer}
				>
					{/* {console.log('availability first: ' + JSON.stringify(availability))} */}
					{userType === 'superadmin' ? (
						<>
							<Table
								className={styles.table}
								aria-label='Lot assignment table'
							>
								<TableHead>
									<TableRow>
										<TableCell>Select</TableCell>
										<TableCell>Lots</TableCell>
										<TableCell align='center'>
											Availability
										</TableCell>
										<TableCell align='center'>
											<TableSortLabel
												active={orderBy === 'lotSize'}
												direction={
													orderBy === 'lotSize'
														? order
														: 'asc'
												}
												onClick={() => {
													handleRequestSort(
														'lotSize'
													);
												}}
											>
												Lot Size (SFT)
											</TableSortLabel>
										</TableCell>
										<TableCell align='center'>
											Closing Dates
										</TableCell>
										<TableCell align='center'>
											Assign Sales Agents
										</TableCell>
										{/* TODO: COBROKER feature */}
										{/* <TableCell align='center'>
											Assign Co-Broker
										</TableCell> */}
										<TableCell align='center'>
											Manage
										</TableCell>
										{Object.keys(selectLot).length > 0 && (
											<TableCell align='center'>
												<Edit
													color='primary'
													onClick={handleEditBatch}
												/>
											</TableCell>
										)}
									</TableRow>
								</TableHead>
								<TableBody>
									{filteredLots &&
										stableSort(
											filteredLots,
											getComparator(order, orderBy)
										)
											.slice(
												page * rowsPerPage,
												page * rowsPerPage + rowsPerPage
											)
											.map((item, index) => {
												console.log(
													'this is the item',
													item
												);
												const isItemSelected =
													isSelected(item.lot);

												console.log(
													'isItemSelected',
													isItemSelected
												);
												const labelId = `enhanced-table-checkbox-${index}`;
												return (
													<TableRow
														hover
														key={item.lot}
														role='checkbox'
													>
														<TableCell padding='checkbox'>
															<Checkbox
																checked={
																	isItemSelected
																}
																inputProps={{
																	'aria-labelledby':
																		labelId,
																}}
																onClick={(
																	event
																) =>
																	handleSelectLots(
																		event,
																		item.lot
																	)
																}
																aria-checked={
																	isItemSelected
																}
																tabIndex={-1}
																key={item.lot}
																selected={
																	isItemSelected
																}
															/>
														</TableCell>
														<TableCell
															component='th'
															scope='row'
														>
															{item.lot}
														</TableCell>
														<TableCell
															component='th'
															scope='row'
															align='center'
														>
															<FormControl component='fieldset'>
																<RadioGroup
																	aria-label='availability'
																	name={
																		item.lot
																	}
																	className={
																		styles.radioGroup
																	}
																	value={
																		availability[
																			'lot' +
																				item.lot
																		]
																	}
																	onChange={
																		handleAvailability
																	}
																>
																	<FormControlLabel
																		value='soldout'
																		control={
																			<Radio
																				className={
																					styles.radioBtn
																				}
																			/>
																		}
																		label='Sold Out'
																	/>
																	<FormControlLabel
																		value='pending'
																		control={
																			<Radio
																				className={
																					styles.radioBtn
																				}
																			/>
																		}
																		label='Pending'
																	/>
																	<FormControlLabel
																		value='available'
																		control={
																			<Radio
																				className={
																					styles.radioBtn
																				}
																			/>
																		}
																		label='Available'
																	/>
																	<FormControlLabel
																		value='hold'
																		control={
																			<Radio
																				className={
																					styles.radioBtn
																				}
																			/>
																		}
																		label='Hold'
																	/>
																</RadioGroup>
															</FormControl>
														</TableCell>
														<TableCell
															component='th'
															scope='row'
															align='center'
														>
															{item.lotSize
																? item.lotSize
																: '-'}
														</TableCell>
														<TableCell
															component='th'
															scope='row'
															align='center'
														>
															{item.closingDate
																? dayjs(
																		item.closingDate
																  ).format(
																		'DD MMM YY'
																  )
																: '-'}
														</TableCell>
														<TableCell
															component='th'
															scope='row'
															align='right'
														>
															<FormControl
																className={
																	styles.formControl
																}
															>
																<Select
																	labelId='demo-mutiple-chip-label'
																	id='demo-mutiple-chip'
																	multiple
																	name={
																		item.lot
																	}
																	value={
																		personName[
																			'agent' +
																				item.lot
																		]
																	}
																	onChange={
																		handleSalesAgent
																	}
																	input={
																		<Input id='select-multiple-chip' />
																	}
																	renderValue={(
																		selected
																	) => (
																		<div
																			className={
																				styles.chips
																			}
																		>
																			{selected?.map(
																				(
																					value
																				) => (
																					<Chip
																						key={
																							value
																						}
																						label={
																							value
																						}
																						className={
																							styles.chip
																						}
																					/>
																				)
																			)}
																		</div>
																	)}
																	MenuProps={
																		MenuProps
																	}
																>
																	{salesAgent.map(
																		(
																			name
																		) => (
																			<MenuItem
																				key={
																					name
																				}
																				value={
																					name
																				}
																				style={getStyles(
																					name,
																					personName[
																						'agent' +
																							item.lot
																					],
																					theme
																				)}
																			>
																				{
																					name
																				}
																			</MenuItem>
																		)
																	)}
																</Select>
															</FormControl>
														</TableCell>
														{/* TODO: COBROKER feature */}
														{/* <TableCell>
															{coBroker && (
																<FormControl
																	className={
																		styles.formControl
																	}
																>
																	<Select
																		labelId='demo-simple-select-label'
																		id='demo-simple-select'
																		name={
																			item.lot
																		}
																		value={
																			coBroker[
																				'cobroker' +
																					item?.lot
																			]
																		}
																		onChange={(
																			e
																		) =>
																			handleChangeCoBroker(
																				e
																			)
																		}
																	>
																		<MenuItem value=''>
																			None
																		</MenuItem>
																		{coBrokersArr?.map(
																			(
																				coBrokerKey
																			) => (
																				<MenuItem
																					value={
																						coBrokerKey?.coBrokerEmail
																					}
																				>
																					{
																						coBrokerKey.coBrokerFullName
																					}
																				</MenuItem>
																			)
																		)}
																	</Select>
																</FormControl>
															)}
														</TableCell> */}
														<TableCell
															component='th'
															scope='row'
														>
															<div
																data-lot={
																	item.lot
																}
																data-closingdate={
																	item.closingDate
																}
																data-premium={
																	item.premiumValue
																}
																data-description={
																	item.premiumDescription
																}
																onClick={(
																	e
																) => {
																	setResetPage(
																		false
																	);
																	openEditModal(
																		e
																	);
																}}
															>
																<Edit color='primary' />
															</div>
														</TableCell>
													</TableRow>
												);
											})}
								</TableBody>
							</Table>
							<Modal
								show={show}
								close={closeModalHandler}
								title='Choose a client and create a document '
								buttonName='Close'
								button={closeModalHandler}
							>
								<Clients lotId={lotId} />
							</Modal>
						</>
					) : null}
					{userType === 'admin' ||
					userType === 'salesadmin' ||
					userType === 'cobroker' ? (
						<>
							<Table
								className={styles.table}
								aria-label='Lot assignment table'
							>
								<TableHead>
									<TableRow>
										<TableCell>Lots</TableCell>
										<TableCell align='right'>
											Availability
										</TableCell>
										<TableCell align='right'>
											Assigned Sales Agents
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{filteredLots &&
										stableSort(
											filteredLots,
											getComparator(order, orderBy)
										)
											.slice(
												page * rowsPerPage,
												page * rowsPerPage + rowsPerPage
											)
											.map((item, index) => {
												return (
													<TableRow key={item.lot}>
														<TableCell
															component='th'
															scope='row'
														>
															{item.lot}
														</TableCell>
														<TableCell
															component='th'
															scope='row'
															align='right'
														>
															<FormControl component='fieldset'>
																{
																	availability[
																		'lot' +
																			item.lot
																	]
																}
															</FormControl>
														</TableCell>
														<TableCell
															component='th'
															scope='row'
															align='right'
														>
															<div className='agent_chip_group'>
																{personName[
																	'agent' +
																		item.lot
																]?.map((x) => {
																	return (
																		<div className='agent_chip'>
																			{x}
																		</div>
																	);
																})}
															</div>
														</TableCell>
													</TableRow>
												);
											})}
								</TableBody>
							</Table>
							<Modal
								show={show}
								close={closeModalHandler}
								title='Choose a client and create a document '
								buttonName='Close'
								button={closeModalHandler}
							>
								<Clients lotId={lotId} />
							</Modal>
						</>
					) : null}
					{userType === '' ? (
						<>
							<Table
								className={styles.table}
								aria-label='Lot assignment table'
							>
								<TableHead>
									<TableRow>
										<TableCell>Lots</TableCell>
										<TableCell align='right'>
											Availability
										</TableCell>
										<TableCell align='right'>
											Assigned Sales Agents
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{filteredLots &&
										stableSort(
											filteredLots,
											getComparator(order, orderBy)
										)
											.slice(
												page * rowsPerPage,
												page * rowsPerPage + rowsPerPage
											)
											.map((item, index) => {
												return (
													<TableRow key={item.lot}>
														<TableCell
															component='th'
															scope='row'
														>
															{item.lot}
														</TableCell>
														<TableCell
															component='th'
															scope='row'
															align='right'
														>
															<FormControl component='fieldset'>
																{
																	availability[
																		'lot' +
																			item.lot
																	]
																}
															</FormControl>
														</TableCell>
													</TableRow>
												);
											})}
								</TableBody>
							</Table>
						</>
					) : null}
				</TableContainer>
				{userType !== 'client' && (
					<TablePagination
						rowsPerPageOptions={[5, 10, 25, 50]}
						component='div'
						count={filteredLots?.length}
						rowsPerPage={rowsPerPage}
						page={page}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
						className='tablePagination'
						labelRowsPerPage={
							<div style={{ color: 'var(--text-high-emphasis)' }}>
								Rows per page
							</div>
						}
						nextIconButtonProps={{
							style: {
								padding: '0px',
							},
						}}
						backIconButtonProps={{
							style: {
								padding: '0px',
								marginLeft: '-10px',
							},
						}}
						SelectProps={{
							style: {
								border: '1px solid var(--text-mid-emphasis)',
								borderRadius: '4px',
								padding: '4px',
								marginRight: '10px',
							},
						}}
					/>
				)}
				<Modal
					show={viewEditModal}
					close={closeModalHandler}
					title='Edit Lot Information'
				>
					<EditLot
						editLotInfo={editLotInfo ? editLotInfo : ''}
						closeModalHandler={closeModalHandler}
						handleHistory={handleHistory}
					/>
				</Modal>
				<Modal
					show={showEditHistory}
					close={closeModalHandler}
					title='View edit history'
					buttonName='Close'
					button={closeModalHandler}
				>
					<ViewHistory
						historyTrails={historyTrails}
						resetPage={resetPage}
					/>
				</Modal>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	userType: state.signIn.userType,
	userDetails: state.signIn,
	clients: state.clients.allVisibleClients,
});

export default connect(mapStateToProps)(Siteplan);
